module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Chapter_Page"
  }, [_c('h2', {
    staticClass: "toc-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/05_Chapter1",
      "id": "s1"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("1.")]), _vm._v("Q&A")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/06_Chapter2",
      "id": "s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("2.")]), _vm._v("Dogs & Cats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/07_Chapter3",
      "id": "s3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("3.")]), _vm._v("Yum Yuks!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/08_Chapter4",
      "id": "s4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("4.")]), _vm._v("Arrr!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09_Chapter5",
      "id": "s5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("5.")]), _vm._v("Fairy Funny!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_Chapter6",
      "id": "s6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("6.")]), _vm._v("Knock-Knock!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter7",
      "id": "s7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("7.")]), _vm._v("Elephants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter8",
      "id": "s8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("8.")]), _vm._v("Humdingers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter9",
      "id": "s9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("9.")]), _vm._v("Space Case")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter10",
      "id": "s10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("10.")]), _vm._v("One-Liners")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter11",
      "id": "s11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("11.")]), _vm._v("Animal Antics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter12",
      "id": "s12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("12.")]), _vm._v("’Snot Funny")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter13",
      "id": "s13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("13.")]), _vm._v("Who Farted?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter14",
      "id": "s14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("14.")]), _vm._v("Br-a-a-ains!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter15",
      "id": "s15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("15.")]), _vm._v("Real Stinkers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter16",
      "id": "s16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("16.")]), _vm._v("Don’t Eat That!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter17",
      "id": "s17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("17.")]), _vm._v("Creature Feature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter18",
      "id": "s18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("18.")]), _vm._v("Yes We Cannibal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter19",
      "id": "s19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("19.")]), _vm._v("That’s Sick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter20",
      "id": "s20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("20.")]), _vm._v("Monster Mash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter21",
      "id": "s21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("21.")]), _vm._v("Last Gasp")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b8f8cf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Contents.vue
// module id = 63
// module chunks = 0